// event sources
export var AREASERIES_EVENT_SOURCE = 'AREASERIES_EVENT_SOURCE';
export var AREASTACK_EVENT_SOURCE = 'AREASTACK_EVENT_SOURCE';
export var BARGROUP_EVENT_SOURCE = 'BARGROUP_EVENT_SOURCE';
export var BARSERIES_EVENT_SOURCE = 'BARSERIES_EVENT_SOURCE';
export var BARSTACK_EVENT_SOURCE = 'BARSTACK_EVENT_SOURCE';
export var GLYPHSERIES_EVENT_SOURCE = 'GLYPHSERIES_EVENT_SOURCE';
export var LINESERIES_EVENT_SOURCE = 'LINESERIES_EVENT_SOURCE';
export var XYCHART_EVENT_SOURCE = 'XYCHART_EVENT_SOURCE';